var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadset = function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".headset_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5h1c1.934 0 3.5-1.067 3.5-3v-2.17",
    className: "headset_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.5a4 4 0 0 1 1.334 7.772 1 1 0 0 1-1.334-.942ZM4.5 8.5a4 4 0 0 0-1.334 7.772A1 1 0 0 0 4.5 15.33ZM19.5 10V8a7.5 7.5 0 0 0-15 0v2M11.5 20.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a1 1 0 0 1-1-1v0a1 1 0 0 1 1-1",
    className: "headset_svg__a"
  })));
};
export default SvgHeadset;